import React from 'react'
import FixedAngleOfViewDisplay from './FixedAngleOfViewDisplay'
import RangeAngleOfViewDisplay from './RangeAngleOfViewDisplay'
import modelAovType from 'helpers/modelAovType'
import { CONVENTIONAL } from 'helpers/globals'

class AngleOfViewContainer extends React.Component {
  properAngleOfView({ fovMode, model: { aov: { min, max, minVertical, maxVertical } } }) {
    return Object.assign({
      min: fovMode === CONVENTIONAL ? min : minVertical
    },
    max && {
      max: fovMode === CONVENTIONAL ? max : maxVertical
    })
  }

  properFov = _ =>
    this.props.currentCamera.fovMode === CONVENTIONAL
    ? this.props.currentCamera.horizontalAngleOfView
    : this.props.currentCamera.verticalAngleOfView

  childToRender({ props: { currentCamera: { model, id, horizontalAngleOfView, verticalAngleOfView, fovMode, distance }, currentCamera, statelessComponent, callback, uiAction, bottomRowToggle } }) {
    switch (modelAovType(model)) {
      case 'variable':
        return statelessComponent
      case 'fixed':
        return <FixedAngleOfViewDisplay value={this.properAngleOfView(currentCamera).min} uiAction={uiAction} bottomRowToggle={bottomRowToggle} />
      case 'range':
        return (
          <RangeAngleOfViewDisplay
            callback={callback}
            id={id}
            min={this.properAngleOfView(currentCamera).min}
            max={this.properAngleOfView(currentCamera).max}
            angleOfView={this.properFov()}
            angleToUpdate={fovMode === CONVENTIONAL ? 'horizontal' : 'vertical'}
            uiAction={uiAction}
            bottomRowToggle={bottomRowToggle}
          />
        )
    }
  }

  render() {
    return this.childToRender(this)
  }
}

export default AngleOfViewContainer



// WEBPACK FOOTER //
// ./src/components/AngleOfViewContainer/index.js